import { Link } from "react-router-dom";
import type { PostItem } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

interface FeaturedStoryProps {
  post: PostItem;
}

export default function FeaturedStory({ post }: FeaturedStoryProps) {
  return (
    <article className="group grid grid-cols-1 lg:grid-cols-2 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
      <Link to={`/article/${post.id}`} className="relative block h-56 lg:h-full min-h-[16rem] overflow-hidden">
        <img
          src={post.cover}
          alt={`${post.title}相关配图`}
          title={`${post.title} - 吃瓜看料`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50 whitespace-nowrap">
          <i className="ri-flashlight-fill" aria-hidden="true"></i>
          今日头条
        </span>
      </Link>
      <div className="flex flex-col justify-center p-5 md:p-7">
        <span className="text-xs font-semibold tracking-wider text-secondary-600">
          {post.categoryName}
        </span>
        <Link to={`/article/${post.id}`}>
          <h3 className="mt-2 font-heading text-xl md:text-2xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
            {post.title}
          </h3>
        </Link>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3">
          {post.excerpt}
        </p>
        <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-user-3-line" aria-hidden="true"></i>
            {post.author}
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-calendar-line" aria-hidden="true"></i>
            {post.publishedAt}
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {formatCount(post.views)}
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap text-primary-600">
            <i className="ri-fire-line" aria-hidden="true"></i>
            热度 {formatCount(post.heat)}
          </span>
        </div>
        <Link
          to={`/article/${post.id}`}
          className="mt-6 inline-flex w-fit items-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
        >
          阅读全文
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </article>
  );
}